const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Forma-1",
    serifId: "Forma 1",
    transform: "matrix(1,0,0,1,-1281,-32)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1293,32C1286.37,32 1281,37.373 1281,44C1281,50.627 1286.37,56 1293,56C1299.63,56 1305,50.627 1305,44C1304.99,37.376 1299.62,32.007 1293,32ZM1299.61,40.32L1291.04,48.892C1290.7,49.226 1290.16,49.226 1289.82,48.892L1286.39,45.463C1286.05,45.134 1286.04,44.592 1286.37,44.251C1286.7,43.911 1287.24,43.901 1287.59,44.23C1287.59,44.237 1287.6,44.244 1287.61,44.251L1290.43,47.074L1298.39,39.108C1298.73,38.779 1299.28,38.789 1299.61,39.129C1299.93,39.461 1299.93,39.988 1299.61,40.32Z",
    style: {
      fill: "rgb(43,221,63)",
      fillRule: "nonzero"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success-icon.3ad42fb71deede4e94134127b6315f41.svg";
export { ForwardRef as ReactComponent };